// extracted by mini-css-extract-plugin
export default {"tableRow":"Alerts_tableRow__UoYaV","alertsContainer":"Alerts_alertsContainer__gxiYZ"};